import "core-js/proposals/url";

import React from "react";
import App from "containers/App";
import ReactDOM from "react-dom";

console.info("Build", process.env.VERSION, "at", process.env.BUILD_DATE);

ReactDOM.render(<App />, document.getElementById("app"));

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js")
      .then(async registration => {
        console.log("Service worker registered.");
      }).catch(err => {
        console.error("Service worker registration failed", err);
      });
  });
}
